var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{staticClass:"gl-vertical-align-middle",attrs:{"variant":_vm.workItemStateVariant}},[_c('gl-icon',{attrs:{"name":_vm.workItemStateIcon,"size":16}}),_vm._v(" "),_c('span',{staticClass:"gl-display-none gl-sm-display-block gl-ml-2"},[_vm._v(_vm._s(_vm.stateText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }